import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { Container } from './ErrorBoundary.styles'
import PageNotFound from '../../assets/images/page-not-found.jpg'

const StyledImage = styled.img`
  width: 90%;
  height: 90%;
  object-fit: cover;
`

type ErrorBoundaryProps = {
  children: ReactNode
}

type ErrorBoundaryState = {
  hasError: boolean
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    console.log('Error:', error)
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('Uncaught error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container>
          <StyledImage src={PageNotFound} alt="Page not found illustration" />
        </Container>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
